<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">
    <div class="flex sm:flex-row flex-0 sm:items-center sm:justify-between p-6 pb-22 sm:pt-12 sm:pb-28 sm:px-10 bg-default dark:bg-transparent">
        <div class="flex-1 min-w-0">
            <div>
                <div class="flex">
                    <a class="inline-flex items-center -ml-1.5 text-secondary font-medium" [routerLink]="'/profile-dashboard'">
                        <mat-icon class="icon-size-5 text-secondary" [svgIcon]="'heroicons_solid:chevron-left'"></mat-icon>
                        <span class="ml-1">Back</span>
                    </a>
                </div>
            </div>
            <div class="mt-2">
                <h2 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
                    List of Programs
                </h2>
            </div>
        </div>
        <div class="flex shrink-0 items-center sm:ml-4" *ngIf="canCreate()">
            <button class="ml-3" mat-flat-button [routerLink]="'/create-program'" [color]="'primary'">
                Create Program
            </button>
        </div>
    </div>
    <div class="flex-auto -mt-16 p-6 sm:p-10 rounded-t-2xl shadow overflow-y-auto bg-card" cdkScrollable>
        <!-- Permission check message -->
        <div *ngIf="!canView()" class="w-full py-4 text-center font-bold text-lg text-gray-600 dark:text-gray-300">
            You don't have permission to view programs.
        </div>

        <!-- Content for users with view permission -->
        <div *ngIf="canView()" class="flex flex-0 flex-col sm:flex-row sm:items-center sm:justify-between">
            <div *ngIf="dataSource.length === 0" class="w-full py-4 text-center font-bold text-lg text-gray-600 dark:text-gray-300">
                No Program found.
            </div>

            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 w-full" *ngIf="dataSource.length > 0">
                <!-- Your existing table columns -->
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> Program Name </th>
                    <td mat-cell *matCellDef="let element" class="clickable" (click)="goToProgramDetail(element?.Id)">
                        {{element?.Name}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="programFee">
                    <th mat-header-cell *matHeaderCellDef> Program Fee </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.Program_Fee__c | currency: 'CAD' }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="location">
                    <th mat-header-cell *matHeaderCellDef> Community </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.Program_Location__c}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="startDate">
                    <th mat-header-cell *matHeaderCellDef> Start Date </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.Start_Date__c}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="endDate">
                    <th mat-header-cell *matHeaderCellDef> End Date </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.End_Date__c}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="isActive">
                    <th mat-header-cell *matHeaderCellDef> Status </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="flex items-center gap-2">
                            <span [ngClass]="{
                                'text-[#7cbd4a] font-semibold': element?.Is_Active__c,
                                'text-red-400': !element?.Is_Active__c
                            }">
                                {{ element?.Is_Active__c ? 'Active' : 'Inactive' }}
                            </span>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions" *ngIf="canEdit()">
                    <th mat-header-cell *matHeaderCellDef> Actions </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-icon-button color="accent" (click)="editProgram(element)">
                            <mat-icon>edit</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>
    </div>
</div>